/* Maen Donati theme — no dependencies. */
(function(){
  var d = document;
  var on = function(sel, evt, fn, root){ (root||d).addEventListener(evt, function(e){ var t = e.target.closest(sel); if (t) fn(e, t); }); };
  var money = function(cents){ return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : (cents/100).toFixed(2); };

  /* ---- drawer + cart ---- */
  function drawer(open){
    var dr = d.getElementById('cart-drawer'), sc = d.getElementById('cart-scrim');
    if (!dr) return;
    if (open){ dr.setAttribute('data-open',''); sc.setAttribute('data-open',''); d.body.style.overflow='hidden'; }
    else { dr.removeAttribute('data-open'); sc.removeAttribute('data-open'); d.body.style.overflow=''; }
  }
  function applySections(sections){
    if (!sections) return;
    var tmp = d.createElement('div');
    if (sections['cart-drawer']){ tmp.innerHTML = sections['cart-drawer']; var fresh = tmp.querySelector('#cart-drawer'), cur = d.getElementById('cart-drawer');
      if (fresh && cur){ var was = cur.hasAttribute('data-open'); cur.replaceWith(fresh); if (was) fresh.setAttribute('data-open',''); } }
    if (sections['header']){ tmp.innerHTML = sections['header']; var c = tmp.querySelector('[data-cart-count]'); var live = d.querySelector('[data-cart-count]');
      if (c && live) live.textContent = c.textContent; }
  }
  async function refreshCart(){
    /* Fallback path only (kept for anything that doesn't return sections inline). */
    var res = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,header');
    var json = await res.json();
    applySections(json);
  }
  on('[data-cart-open]', 'click', function(e){ e.preventDefault(); drawer(true); });
  on('[data-cart-close]', 'click', function(e){ e.preventDefault(); drawer(false); });
  d.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ drawer(false); overlay(false); } });

  on('[data-product-form]', 'submit', async function(e, form){
    if (form.dataset.cartType === 'page') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); var label = btn ? btn.textContent : '';
    if (btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      var body = new FormData(form);
      /* Ask Shopify to render the drawer + header sections in the SAME response,
         instead of a second round-trip via refreshCart(). Cuts add-to-bag latency roughly in half. */
      body.append('sections', 'cart-drawer,header');
      body.append('sections_url', window.location.pathname);
      var res = await fetch(window.Shopify.routes.root + 'cart/add.js', { method:'POST', body: body });
      var json = await res.json();
      if (json && json.sections) { applySections(json.sections); } else { await refreshCart(); }
      drawer(true);
    } finally { if (btn){ btn.disabled = false; btn.textContent = label; } }
  });

  on('[data-qty]', 'click', async function(e, btn){
    e.preventDefault();
    var line = btn.getAttribute('data-line'), q = parseInt(btn.getAttribute('data-qty'), 10);
    /* Same fix as add-to-bag: request the re-rendered sections inline instead of
       a separate refreshCart() fetch after the change completes. This was the
       cause of the 1-2s delay on quantity +/- and remove in the drawer. */
    var res = await fetch(window.Shopify.routes.root + 'cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ line: parseInt(line,10), quantity: Math.max(0, q), sections: 'cart-drawer,header', sections_url: window.location.pathname }) });
    if (d.body.classList.contains('template-cart')) { location.reload(); return; }
    var json = await res.json();
    if (json && json.sections) { applySections(json.sections); } else { await refreshCart(); }
  });

  /* ---- navigation ---- */
  function overlay(open){
    var el = d.getElementById('overlay-nav'); if (!el) return;
    if (open){ el.setAttribute('data-open',''); d.body.style.overflow='hidden'; } else { el.removeAttribute('data-open'); d.body.style.overflow=''; }
  }
  on('[data-nav-open]', 'click', function(e){ e.preventDefault(); overlay(true); });
  on('[data-nav-close]', 'click', function(e){ e.preventDefault(); overlay(false); });
  on('[data-mega]', 'mouseenter', function(e, el){
    d.querySelectorAll('[data-mega-panel]').forEach(function(p){ p.removeAttribute('data-open'); });
    var panel = d.querySelector('[data-mega-panel="' + el.getAttribute('data-mega') + '"]');
    if (panel) panel.setAttribute('data-open','');
  });
  var header = d.querySelector('.header');
  if (header) header.addEventListener('mouseleave', function(){ d.querySelectorAll('[data-mega-panel]').forEach(function(p){ p.removeAttribute('data-open'); }); });

  /* ---- accordions ---- */
  on('.accordion__btn', 'click', function(e, btn){
    var item = btn.closest('.accordion__item'), open = item.hasAttribute('data-open');
    if (btn.closest('[data-single]')) item.parentElement.querySelectorAll('.accordion__item').forEach(function(i){ i.removeAttribute('data-open'); i.querySelector('.accordion__btn span:last-child').textContent = '+'; });
    if (open){ item.removeAttribute('data-open'); } else { item.setAttribute('data-open',''); }
    var mark = btn.querySelector('span:last-child'); if (mark) mark.textContent = open ? '+' : '−';
  });

  /* ---- product: gallery + variants ---- */
  on('[data-thumb]', 'click', function(e, btn){
    var wrap = btn.closest('[data-gallery]');
    var main = wrap.querySelector('[data-gallery-main]');
    var cap = wrap.querySelector('[data-gallery-caption]');
    main.src = btn.getAttribute('data-src'); main.srcset = '';
    if (cap) cap.textContent = btn.getAttribute('data-caption') || '';
    wrap.querySelectorAll('[data-thumb]').forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
  });

  d.querySelectorAll('[data-variants]').forEach(function(root){
    var data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var submit = root.querySelector('[type="submit"]');
    var priceEl = root.querySelector('[data-price]');
    var note = root.querySelector('[data-size-note]');
    function selected(){
      return Array.from(root.querySelectorAll('[data-option-index]')).map(function(g){
        var sel = g.querySelector('[data-option-select]');
        if (sel) return sel.value;
        var active = g.querySelector('[aria-pressed="true"]');
        return active ? active.getAttribute('data-value') : null;
      });
    }
    function sync(){
      var chosen = selected();
      var match = data.find(function(v){ return v.options.every(function(o, i){ return chosen[i] == null || o === chosen[i]; }) && chosen.every(function(c){ return c !== null; }); });
      var needsChoice = chosen.some(function(c){ return c === null; });
      if (idInput && match) idInput.value = match.id;
      if (priceEl && match) priceEl.textContent = money(match.price);
      if (submit){
        submit.disabled = needsChoice || !match || !match.available;
        submit.textContent = needsChoice ? (submit.getAttribute('data-choose') || 'Select a size')
          : (match && match.available ? (submit.getAttribute('data-add') || 'Add to bag') : (submit.getAttribute('data-soldout') || 'Sold out'));
      }
      if (note) note.textContent = (match && match.available) ? (note.getAttribute('data-in-stock') || '') : (note.getAttribute('data-default') || '');
      var sticky = d.querySelector('[data-sticky-atc] [data-sticky-size]');
      if (sticky) sticky.textContent = needsChoice ? (sticky.getAttribute('data-empty') || '') : chosen.join(' · ');
      if (match){
        history.replaceState({}, '', '?variant=' + match.id);
        var main = d.querySelector('[data-gallery-main]');
        if (main && match.featured_media){ main.src = match.featured_media; main.srcset = ''; }
      }
    }
    on('[data-value]', 'click', function(e, btn){
      e.preventDefault();
      if (btn.hasAttribute('disabled')) return;
      var group = btn.closest('[data-option-index]');
      group.querySelectorAll('[data-value]').forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var lbl = group.parentElement.querySelector('[data-option-label]');
      if (lbl) lbl.textContent = btn.getAttribute('data-value');
      sync();
    }, root);
    on('[data-option-select]', 'change', function(){ sync(); }, root);
    on('[data-qty-step]', 'click', function(e, btn){
      e.preventDefault();
      var input = root.querySelector('input[name="quantity"]');
      if (!input) return;
      var next = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, next);
    }, root);
    sync();
  });

  /* ---- share ---- */
  on('[data-share]', 'click', async function(e, btn){
    var url = btn.getAttribute('data-share');
    if (navigator.share){ try { await navigator.share({ url: url, title: d.title }); return; } catch(err){} }
    try { await navigator.clipboard.writeText(url); btn.textContent = 'Link copied'; } catch(err){}
  });

  /* ---- header hides on scroll down ---- */
  var hideHdr = d.querySelector('[data-hide-on-scroll]');
  if (hideHdr){
    var last = 0;
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      if (y > 200 && y > last) hideHdr.style.transform = 'translateY(-100%)';
      else hideHdr.style.transform = '';
      last = y;
    }, { passive: true });
  }

  /* ---- sticky add to bag ---- */
  var atc = d.querySelector('[data-sticky-atc]'), anchor = d.querySelector('[data-atc-anchor]');
  if (atc && anchor && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) atc.setAttribute('data-hidden','');
        else atc.removeAttribute('data-hidden');
      });
    }, { rootMargin: '-90px 0px -10px 0px' }).observe(anchor);
  }

  /* ---- facets: auto-submit ---- */
  on('[data-facet-form] input', 'change', function(e, input){ input.closest('form').requestSubmit(); });
  on('[data-facet-toggle]', 'click', function(e, btn){
    var panel = d.getElementById('facets'); if (!panel) return;
    if (panel.hasAttribute('data-open')) panel.removeAttribute('data-open'); else panel.setAttribute('data-open','');
  });
  on('[data-sort]', 'click', function(e, btn){
    e.preventDefault();
    var url = new URL(location.href); url.searchParams.set('sort_by', btn.getAttribute('data-sort')); location.href = url.toString();
  });

  /* ---- sticky header: the section wrapper carries it ---- */
  (function(){
    var hdr = d.querySelector('header.header[data-sticky="true"]');
    if (!hdr) return;
    var wrap = hdr.closest('[id^="shopify-section-"]') || hdr.parentElement;
    if (hdr.classList.contains('header--transparent')){
      var fix = function(){
        if (window.scrollY > hdr.offsetHeight){ wrap.classList.add('is-fixed'); hdr.classList.add('is-solid'); }
        else { wrap.classList.remove('is-fixed'); if (hdr.hasAttribute('data-solid-on-scroll') === false) hdr.classList.remove('is-solid'); }
      };
      window.addEventListener('scroll', fix, { passive: true });
      fix();
      return;
    }
    if (getComputedStyle(wrap).position === 'sticky') return;
    wrap.style.position = 'sticky';
    wrap.style.top = '0';
    wrap.style.zIndex = '65';
  })();

  /* ---- announcement bar: rotate + dismiss ---- */
  var ann = d.getElementById('announce');
  if (ann){
    if (sessionStorage.getItem('md-announce-hidden') === '1' && ann.hasAttribute('data-dismissible')) ann.style.display = 'none';
    var msgs = ann.querySelectorAll('.announce__msg');
    var speed = parseFloat(ann.getAttribute('data-rotate') || '0');
    if (msgs.length > 1 && speed > 0){
      var i = 0;
      setInterval(function(){
        msgs[i].removeAttribute('data-active');
        i = (i + 1) % msgs.length;
        msgs[i].setAttribute('data-active','');
      }, speed * 1000);
    }
    on('[data-announce-close]', 'click', function(){ ann.style.display = 'none'; sessionStorage.setItem('md-announce-hidden','1'); });
  }

  /* ---- transparent header turns solid on scroll ---- */
  var hdr = d.querySelector('.header--transparent[data-solid-on-scroll]');
  if (hdr){
    var onScroll = function(){
      if (window.scrollY > (window.innerHeight * 0.55)) hdr.classList.add('is-solid');
      else hdr.classList.remove('is-solid');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- recently viewed ---- */
  var KEY = 'md-recent';
  var current = d.body.getAttribute('data-product-handle');
  if (current){
    var list = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function(h){ return h !== current; });
    list.unshift(current); localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
  }
  var slot = d.querySelector('[data-recently-viewed]');
  if (slot){
    var handles = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function(h){ return h !== current; }).slice(0, 4);
    if (!handles.length){ slot.remove(); }
    else {
      Promise.all(handles.map(function(h){
        return fetch(window.Shopify.routes.root + 'products/' + h + '?section_id=product-card-fragment')
          .then(function(r){ return r.ok ? r.text() : ''; })
          .catch(function(){ return ''; })
          .then(function(html){
            /* Reject anything that is not a real card fragment: 404 pages, redirects,
               full documents, or app-injected markup would otherwise be dumped in. */
            if (!html) return null;
            var probe = d.createElement('div');
            probe.innerHTML = html;
            if (probe.querySelector('html, head, body, title')) return null;
            var card = probe.querySelector('[data-product-card]') || probe.querySelector('a[href*="/products/"]');
            if (!card) return null;
            /* Guard against a stale handle resolving to a different product. */
            var link = card.matches('a[href]') ? card : card.querySelector('a[href*="/products/"]');
            if (link && link.getAttribute('href').indexOf('/products/' + h) === -1) return null;
            return probe.firstElementChild ? probe.innerHTML : null;
          });
      })).then(function(parts){
        var good = parts.filter(function(p){ return p; });
        /* Drop handles that no longer resolve so they are not retried forever. */
        if (good.length !== handles.length){
          var keep = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function(h, i){
            var idx = handles.indexOf(h);
            return idx === -1 || parts[idx];
          });
          localStorage.setItem(KEY, JSON.stringify(keep));
        }
        if (!good.length){ slot.remove(); return; }
        slot.querySelector('[data-recent-grid]').innerHTML = good.join('');
        slot.removeAttribute('hidden');
      }).catch(function(){ slot.remove(); });
    }
  }
})();
